import style from './PatentedTechnology.module.css';
import React from 'react';
import { PATH_ARTICLES, PATH_DEMO } from '@/constants/spa-routes';
import Link from 'next/link';
import { BlackButton } from '@/components/ButtonsCollection/BlackButton/BlackButton';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/constants/colors';
import { SmallArrowIcon } from '@/assets/icons/smallArrowIcon';
import { Container } from '@/components/Containers/Container';
import { clsx } from 'clsx';

export const PatentedTechnology = () => {
  return (
    <section className="relative bg-light">
      <Container className="md:pt-24.5-vw pt-15">
        <div className="flex items-center flex-col">
          <div className={clsx(style.title, 'md:w-9/12 md:text-center')}>
            <Typography as="h2" $type="Heading1" className="font-formula lg:w-5/6">
              Patented AI Technology in our Products
            </Typography>
            <div className="flex flex-col mb-7.5">
              <Typography $type="Heading4" className="opacity-70 font-jamjuree">
                In January 2024, CoSupport Al was granted a patent by the US Patent and Trademark
                Office. This patent solidifies the uniqueness and value of the technology underlying
                CoSupport™ Agent, which features our proprietary formula for high-speed and
                consistent responses in customer support. Thanks to this technology, CoSupport™
                Agent provides responses 3x faster than ChatGPT, saving companies time,
                computational resources, and costs.
              </Typography>
              <Link prefetch={false} href={PATH_ARTICLES.PATENT} className="underline text-white">
                <Typography $type="Heading4" className="underline font-jamjuree">
                  <i>
                    <b>
                      <span>Learn more →</span>
                    </b>
                  </i>
                </Typography>
              </Link>
            </div>
          </div>
          <BlackButton
            url={PATH_DEMO.SCHEDULE_DEMO}
            className="whitespace-nowrap"
            linkBtnClassName="max-md:w-full"
          >
            <Typography as="span" $color={COLORS.WHITE} $type="Heading4" $weight="700">
              Request demo now
            </Typography>
            <SmallArrowIcon />
          </BlackButton>
          <div className="md:mt-8-vw mt-10 md:w-9/12">
            <picture className="w-full h-full object-contain">
              <source
                srcSet={'/img/freshdesk-integration/pattent_image.webp'}
                media="(min-width: 640px)"
              />
              <img
                className="h-full w-full object-contain object-bottom"
                src="/img/freshdesk-integration/pattent_image-mobile.webp"
                alt={`patent-technology image`}
              />
            </picture>
          </div>
        </div>
      </Container>
    </section>
  );
};
